<template>
  <font-awesome-icon
    icon="arrows-alt-h"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowsAltH } from '@fortawesome/free-solid-svg-icons'

library.add(faArrowsAltH)

export default {
  name: 'CoozzyArrowsAltHIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
